import reducer from "./reducers";

import * as visitsAction from "./actions";

export { visitsAction };

export default reducer;
